import { render, staticRenderFns } from "./VarillaReports.vue?vue&type=template&id=b26ac618&scoped=true&"
import script from "./VarillaReports.vue?vue&type=script&lang=js&"
export * from "./VarillaReports.vue?vue&type=script&lang=js&"
import style0 from "./VarillaReports.vue?vue&type=style&index=0&id=b26ac618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26ac618",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/abimelec/repositories/nxtagro_op_front/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VDataTable,VDialog,VFlex,VIcon,VLayout,VSelect})
